function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.992188 0.734375L0.773438 0.953125C0.71875 1.00781 0.691406 1.08073 0.691406 1.17188C0.691406 1.26302 0.71875 1.34505 0.773438 1.41797L6.13281 6.75L0.773438 12.082C0.71875 12.1549 0.691406 12.237 0.691406 12.3281C0.691406 12.4193 0.71875 12.4922 0.773438 12.5469L0.992188 12.7656C1.04688 12.8203 1.11979 12.8477 1.21094 12.8477C1.30208 12.8477 1.375 12.8203 1.42969 12.7656L7.22656 6.96875C7.28125 6.91406 7.30859 6.84115 7.30859 6.75C7.30859 6.65885 7.28125 6.58594 7.22656 6.53125L1.42969 0.734375C1.375 0.679688 1.30208 0.652344 1.21094 0.652344C1.11979 0.652344 1.04688 0.679688 0.992188 0.734375Z",
  fill: "currentColor"
});

var SvgChevronRight = function SvgChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-right.96a0c9bf.svg";
export { ForwardRef as ReactComponent };